module.exports = __webpack_public_path__ + "img/pillar_gold.206a4a65.png";